export default "__VITE_ASSET__8o5PlDFh__"